import { type AbsolutePath, DATA, KEY, NUMBER, OPTIONAL_KEY, TIMESTAMP, type ValidatorType, splitEntity } from "shelving";
import { TASK_TYPE } from "./challenge.js";
import { CREATOR_ENTITY, type CreatorEntity } from "./entity.js";

export const LEADERBOARD_MAX = 48;

/** Schema for a leaderboard. */
export const LEADERBOARD_SCHEMA = DATA({
	uid: KEY,
	cid: KEY,
	tid: KEY,
	creator: CREATOR_ENTITY, // Creator entity this leaderboard is attached to (only groups use leaderboards for now but they're built for flexibility).
	type: TASK_TYPE,
	units: OPTIONAL_KEY,
	amount: NUMBER, // Last amount added to this leaderboard by this person.
	total: NUMBER, // Total amount added to this leaderboard by this person.
	joined: TIMESTAMP,
	updated: TIMESTAMP,
});
export type LeaderboardData = ValidatorType<typeof LEADERBOARD_SCHEMA>;

/** Get the ID of a Leaderboard document. */
export const getLeaderboardID = (creator: CreatorEntity, cid: string, tid: string, uid: string): string => `${uid}:${creator}:${cid}:${tid}`;

/** Get the path of a Leaderboard page. */
export function getLeaderboardPath(creator: CreatorEntity, cid?: string): AbsolutePath {
	const [type, id] = splitEntity(creator);
	return `/leaderboard/${type}/${id}${cid ? `/${cid}` : ""}`;
}
